import React from 'react';
import { RoleContextModel } from '../../../../../model/DeviceAdminModel';
import { ActionContext, ContextActionTypes } from './actionTypes';

export const getRoleContextModelInitialState = (): RoleContextModel => {
	return {
		forceRender: 0,
		roles: [],
		props: {
			isDirty: false,
			roleId: 0,
			roleName: '',
			roleDescription: '',
		},
		member: {
			isDirty: false,
			subscribedOperatorIds: [],
		},
		applicationPermissions: {
			isDirty: false,
			applicationPermissions: [],
		},
		generalPermissions: {
			isDirty: false,
			grantedSubPermissions: [],
			modifiedSubPermissions: [],
		},
		hardwarePermissions: {
			isDirty: false,
			globalTimeZoneId: -1,
			modifiedHardwarePermissions: [],
		},
	};
};

const roleContextInitialState: RoleContextModel = getRoleContextModelInitialState();

const roleContextReducer = (state: Readonly<RoleContextModel>, action: ActionContext) => {
	const { type } = action;
	switch (type) {
		case ContextActionTypes.SET_FORCE_RENDER_CONTEXT_MODEL: {
			return {
				...state,
				forceRender: state.forceRender + 1,
			};
		}
		case ContextActionTypes.SET_ROLES_CONTEXT_MODEL: {
			return {
				...state,
				roles: action.payload,
			};
		}
		case ContextActionTypes.SET_ROLE_PROPS_CONTEXT_MODEL: {
			return {
				...state,
				props: {
					...state.props,
					...action.payload,
				},
			};
		}
		case ContextActionTypes.SET_MEMBER_CONTEXT_MODEL: {
			return {
				...state,
				member: {
					...action.payload,
				},
			};
		}
		case ContextActionTypes.SET_APPLICATION_PERMISSION_CONTEXT_MODEL: {
			return {
				...state,
				applicationPermissions: { ...action.payload },
			};
		}
		case ContextActionTypes.SET_GENERAL_PERMISSION_CONTEXT_MODEL: {
			return {
				...state,
				generalPermissions: {
					...state.generalPermissions,
					...action.payload,
				},
			};
		}
		case ContextActionTypes.SET_SELECTED_GENERAL_PERMISSION_CONTEXT_MODEL: {
			return {
				...state,
				generalPermissions: {
					...state.generalPermissions,
					selectedGeneralPermission: action.payload,
				},
			};
		}
		case ContextActionTypes.SET_HARDWARE_PERMISSION_CONTEXT_MODEL: {
			return {
				...state,
				hardwarePermissions: {
					...action.payload,
				},
			};
		}
		case ContextActionTypes.SET_CLEAR_IS_DIRTY_CONTEXT_MODEL: {
			return {
				...state,
				props: {
					...state.props,
					isDirty: false,
				},
				member: {
					...state.member,
					isDirty: false,
				},
				applicationPermissions: {
					...state.applicationPermissions,
					isDirty: false,
				},
				generalPermissions: {
					...state.generalPermissions,
					isDirty: false,
				},
				hardwarePermissions: {
					...state.hardwarePermissions,
					isDirty: false,
				},
			};
		}
		default:
			return { ...state };
	}
};

type RoleModalContext = {
	roleContextInitialState: Readonly<RoleContextModel>;
	dispatcher: React.Dispatch<ActionContext>;
};

const RoleStore = React.createContext<RoleModalContext>({ roleContextInitialState, dispatcher: null });

export { roleContextInitialState, roleContextReducer, RoleStore };
